export interface MenuItem {
  id?: number;
  label?: string;
  link?: string;
  icon?: string;
  options?: Option[];
  visible?: boolean;
  track?: string;
}

export interface Option {
  label: string;
  icon: string;
  action?: any;
}
